// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__3NucY","label":"LabeledBox_label__2eDRU"};